import { SettingCell } from '@/components/setting-cell'
import { StatusPill } from '@/components/status-pill'
import { READINESS_STATUS, useProductStoreReadiness } from '@/features/store-readiness/hooks'

// Problems that rarely happen: shown only when they hold the product.
const RARE_STEPS = new Set(['source', 'listing'])

/** A product that is not live yet: every step it needs before it goes on the store (USA-1131). */
export function ProductStoreReadiness({ productUuid }: { productUuid: string }) {
  const { data } = useProductStoreReadiness(productUuid)
  if (!data || (data.state !== 'waiting' && data.state !== 'not_checked')) return null
  const steps = data.steps ?? []
  const open = steps.filter((step) => step.status !== 'done')
  const done = steps.filter((step) => step.status === 'done' && !RARE_STEPS.has(step.key))
  return (
    <section aria-labelledby="product-store-readiness" className="overflow-hidden rounded-xl border bg-card">
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-0.5 border-b px-4 py-3">
        <h2 id="product-store-readiness" className="text-sm font-semibold">
          Not on the store yet
        </h2>
        {done.length > 0 && (
          <p className="text-xs text-muted-foreground">Done: {done.map((step) => step.label).join(', ')}</p>
        )}
      </div>
      {data.state === 'not_checked' ? (
        <p className="px-4 py-4 text-sm text-muted-foreground">Not checked yet</p>
      ) : (
        <div className="-mb-px -mr-px grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
          {open.map((step) => {
            const status = READINESS_STATUS[step.status]
            return (
              <SettingCell
                key={step.key}
                label={step.label}
                below={step.detail && <p className="text-xs text-muted-foreground">{step.detail}</p>}
              >
                <StatusPill tone={status.tone}>{status.label}</StatusPill>
              </SettingCell>
            )
          })}
        </div>
      )}
    </section>
  )
}
